import { Box } from "@mui/material";
import { CustomerSupportTicket } from "entities/customerTickets/types";
import React, { FC } from "react";
import { COLOR_GREY_2, COLOR_WHITE } from "shared/theme/colors";
import { useCustomerTicketsPage } from "modules/customerTickets/pages/CustomerTickets/context";
import UserInfo from "../../UserInfo";
import TicketStatusInfo from "./components/TicketStatusInfo";
import TicketTitle from "./components/TicketTitle";
import { StyledTicketContainer } from "./styled";

type Props = {
  ticket: CustomerSupportTicket;
};

const Ticket: FC<Props> = ({ ticket }) => {
  const { selectedTicket, ticketsBgColors, handleSelectMessage } =
    useCustomerTicketsPage();
  const userId = ticket?.userId ?? "";

  const ticketAvatarBgColor =
    ticketsBgColors.find(({ id }) => id === ticket.id)?.bgColor || "";

  return (
    <StyledTicketContainer
      onClick={() => handleSelectMessage(ticket)}
      bgColor={selectedTicket === ticket ? COLOR_GREY_2 : COLOR_WHITE}
    >
      <Box display="flex" justifyContent="space-between" width="100%">
        <UserInfo
          userId={userId}
          userName={ticket.userName}
          bgColor={ticketAvatarBgColor}
          unreadMessagesCount={ticket.adminUnreadMessagesCount}
        />
        <Box>
          <TicketStatusInfo status={ticket.status} date={ticket.updatedAt} />
        </Box>
      </Box>
      <TicketTitle title={ticket.title} />
    </StyledTicketContainer>
  );
};

export default Ticket;
